import React, { useEffect, useRef, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../Assets/logo.svg";
import { SiFlathub } from "react-icons/si";
import { scrollToSection } from '../utils/scrollToSection';
import hcontact from "../Assets/hcontact.png"
import { IoCloseSharp } from "react-icons/io5";
import { CgMenuRight } from "react-icons/cg";
import { FaHome, FaUserTie, FaBriefcase, FaEnvelopeOpenText } from "react-icons/fa";
import { MdGroups, MdBusinessCenter, MdEmojiEvents } from "react-icons/md";

const divisionNames = {
  "/Healthcare": "Healthcare",
  "/Agrotech": "Agrotech",
  "/Foundation": "Hitachinthana Charitable Trust",
  "/Hospitality": "Resort & Hospitality",
  "/Technologies": "Technologies",
  "/Builders": "Builders",
  "/Goldandiamonds": "Gold and Diamonds",
  "/Properties": "Properties",
  "/educational": "Educational Institutions",
};

const menuItems = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/aboutVCNR' },
  // { label: 'Our Business'}, // optional if no dedicated route
  { label: 'Leadership', path: '/leadership' },
  { label: 'Career', path: '/career' },
  { label: 'Contact', path: '/Contact' },

];

const menuIcons = {
  Home: <FaHome />,
  About: <SiFlathub />,
  Leadership: <MdEmojiEvents />,
  Career: <FaUserTie />,
  Contact: <FaEnvelopeOpenText />,
  "Our Business": <FaBriefcase />,
};

const businessCategories = [
  { title: 'Builders', image: '/images/builder.png', link: '/Builders' },
  { title: 'Healthcare', image: '/images/health.png', link: '/Healthcare' },
  { title: 'Technologies', image: '/images/tech.png', link: '/Technologies' },
  { title: 'Gold & Diamonds', image: '/images/gold.png', link: '/Goldandiamonds' },
  { title: 'Educational Institutions', image: '/images/edum.png', link: '/educational' },
  { title: 'Properties', image: '/images/propm.png', link: '/Properties' },
  { title: 'Resort & Hospitality', image: '/images/resort.png', link: '/Hospitality' },
  { title: 'Agrotech', image: '/images/agri.png', link: '/Agrotech' },
  { title: 'Hitachinthana Charitable Trust', image: '/images/trust.png', link: '/Foundation' },
];

const homeLinks = [
    { label: 'Our Story', anchor: 'OurStory' },
    {label: 'StoneSection', anchor: 'StoneSection'},
  { label: 'Teams', anchor: 'TeamSection' },
  { label: 'Statistics', anchor: 'StatisticsSection' },
  { label: 'Partner', anchor: 'PartnerSection' },
  { label: 'News', anchor: 'news' },
];

const aboutLinks = [
  { label: 'Our Origin Story', anchor: 'OurOriginStory' },
  { label: 'Our Values', anchor: 'AboutValues' },
  { label: 'Core Values', anchor: 'CoreValues' },
  { label: 'Group Structure', anchor: 'GroupStructure' },
  { label: "Founder's Message", anchor: 'FounderMessage' },
  { label: 'Why VCNR is Different', anchor: 'VCNRDifferent' },
  { label: 'Looking Forward', anchor: 'LookingForward' },
];

const leadershipLinks = [
  { label: "Founder's Message", anchor: 'FounderMessage' },
  { label: 'Core Architects', anchor: 'CoreArchitects' },
  { label: 'Team Video', anchor: 'TeamVideo' },
  { label: 'Foundation & CSR Leader', anchor: 'FoundationandCSRLeader' },
  { label: 'Strategic Functional Advisors', anchor: 'StrategicFunctionalAdvisors' },
  { label: 'Heart of VCNR', anchor: 'HeartofVCNR' },
];
const careerLinks = [
  { label: 'Building a Culture', anchor: 'BuildingaCulture' },
  { label: 'Careers Section', anchor: 'careerssection' },
  { label: 'Career Texts', anchor: 'CareerText' },
  { label: 'Why People Choose VCNR', anchor: 'WhyPeopleChooseVCNR' },
  { label: 'Application Process', anchor: 'ApplicationProcess' },
  { label: 'Build Career With Us', anchor: 'BuildCareerWithUs' },
];

const contactLinks = [
  { label: 'Contact Section', anchor: 'ContactSection' },
  { label: 'VCNR Group', anchor: 'VCNRGroup' },
  { label: 'Enquiry Form', anchor: 'EnquiryForm' },
  { label: 'Media Contact', anchor: 'VCNRMedia' },
  { label: 'Map Location', anchor: 'VCNRMapLocation' },
  { label: 'Clients', anchor: 'VCNRClientsLogo' },
  { label: 'Social Media', anchor: 'VCNRSocialMedia' },
];




const Header = () => {
const [menuOpen, setMenuOpen] = useState(false);
  const [clickedItem, setClickedItem] = useState("Our Business");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [showSubNav, setShowSubNav] = useState(false);
  const [currentSubNavLinks, setCurrentSubNavLinks] = useState([]);
  const [mobileSubNavOpen, setMobileSubNavOpen] = useState(false);
  const divisionRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const handleMenuClick = (sectionId, path = '/') => {
    navigate(`${path}#${sectionId}`);
    setMenuOpen(false);
  };

  const toggleMenuItem = (item) => {
    if (item === 'Our Business') {
      setClickedItem(item);
      setShowSubNav(false);
    } else {
      setClickedItem(item);
      setShowSubNav(true);
      switch(item) {
        case 'Home':
          setCurrentSubNavLinks(homeLinks);
          break;
        case 'About':
          setCurrentSubNavLinks(aboutLinks);
          break;
        case 'Leadership':
          setCurrentSubNavLinks(leadershipLinks);
          break;
        case 'Career':
          setCurrentSubNavLinks(careerLinks);
          break;
        case 'Contact':
          setCurrentSubNavLinks(contactLinks);
          break;
        default:
          setCurrentSubNavLinks([]);
      }
    }
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => document.body.classList.remove("no-scroll");
  }, [menuOpen]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const text = divisionNames[location.pathname] || "";
    if (divisionRef.current) {
      divisionRef.current.classList.remove("animate");
      divisionRef.current.textContent = text;
      void divisionRef.current.offsetWidth;
      divisionRef.current.classList.add("animate");
    }
  }, [location]);

  return (
    <>
    <div className={menuOpen ? "menu-open" : ""}>
      <header className="main-header">
        <div className="logo-container">
          <a href="/"><img src={logo} alt="VCNR Logo" className="logo" /></a>
          <span ref={divisionRef} className="division-text"></span>
        </div>

        <button
      className="menu-toggle"
      aria-label={menuOpen ? "Close menu" : "Open menu"}
      onClick={() => setMenuOpen(!menuOpen)}
    >
      {menuOpen ? (
        <IoCloseSharp className="menu-icon close-icon" />
      ) : (
        <CgMenuRight className="menu-icon menu-icon" />
      )}
    </button>
      </header>
 {/* Horizontal Sub Navigation */}
        {/* {showSubNav && !menuOpen && (
          <>
            <div className={`horizontal-subnav desktop-only ${scrolled ? 'scrolled' : ''}`}>
              <div className="subnav-container">
                {currentSubNavLinks.map((link, index) => (
                  <a
                    key={index}
                    href={`${link.path || location.pathname}#${link.anchor}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.anchor);
                    }}
                    className="subnav-link"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div className={`mobile-subnav mobile-only ${scrolled ? 'scrolled' : ''}`}>
              <button 
                className="mobile-subnav-toggle"
                onClick={() => setMobileSubNavOpen(!mobileSubNavOpen)}
              >
                {clickedItem} Section
                <span className={`toggle-icon ${mobileSubNavOpen ? 'open' : ''}`}>▼</span>
              </button>
              
              {mobileSubNavOpen && (
                <div className="mobile-subnav-dropdown">
                  {currentSubNavLinks.map((link, index) => (
                    <a
                      key={index}
                      href={`${link.path || location.pathname}#${link.anchor}`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection(link.anchor);
                        setMobileSubNavOpen(false);
                      }}
                      className="mobile-subnav-link"
                    >
                      {link.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </>
        )} */}

      {menuOpen && (
        <div className={`menu-wrapper ${menuOpen ? "open" : ""}`}>
          {/* Column 1: Main Menu */}
          <div className="menu-column">
    {menuItems.map((item, index) => {
      const content = (
        <div
          key={index}
          className={`menu-item ${clickedItem === item.label ? 'active' : ''}`}
          onClick={() => toggleMenuItem(item.label)}
        >
          <span className="menu-label">{item.label}</span>
         <span className="icon">
  {menuIcons[item.label] || <FaBriefcase />} {/* default fallback */}
</span>
        </div>
      );

      return item.path ? (
        <Link
          key={index}
          to={item.path}
          onClick={() => setMenuOpen(false)}
          className="menu-link"
        >
          {content}
        </Link>
      ) : (
        content
      );
    })}
  </div>

          {/* Column 2: Dynamic Submenu */}
<div className="submenu-column">
  <h2 className="business-grid-title">Our Business Verticals</h2>
  <div className="business-grid">
    {businessCategories.map((item, index) => (
      <Link
        to={item.link}
        className="business-card"
        key={index}
        onClick={() => setMenuOpen(false)}
      >
        <img src={item.image} alt={item.title} />
        <h3>{item.title}</h3>
      </Link>
    ))}
  </div>
</div>


          {/* Column 3: Static Content */}
          <div className="contact-column">
            <div className="video-box">
              <img src={hcontact} alt="Video" />
             <div className="play-button">▶</div>
            </div>
            <div className="contact-text">
              <h4>Inquiry to Impact. Let’s Begin.</h4>
              <p>
                #195, VCNR Towers, VijayaNagar, <br />
                Near Basaveshwara Engineering College,<br />
                Karnataka - 582103
              </p>
              <a href="/Contact" className="explore-btn">Contact Us</a>
            </div>
          </div>
        </div>
      )}
      </div>
    </>
  );
};

export default Header;
